const initialState = () => ({
  agentsPortfolio: [],
});

const state = initialState();

export default state;
